import { campoDeveSerMaiorQueZero, campoObrigatorio } from 'helpers/Constantes/Mensagens'

export type DadosComercial = {
  descontoItbiRegistro: boolean
  descontoBomPagador: string
  parcelamento: string
  valido: boolean
}

export const dadosComercialValorDefault = {
  descontoItbiRegistro: false,
  descontoBomPagador: '',
  parcelamento: ''
} as DadosComercial

export class ValidacaoDadosComercial {
  descontoBomPagador: string
  parcelamento: string

  constructor(descontoBomPagador = '', parcelamento = '') {
    this.descontoBomPagador = descontoBomPagador
    this.parcelamento = parcelamento
  }

  validarDescontoBomPagador(descontoBomPagador: string): string {
    let error = ''
    if (parseFloat(descontoBomPagador) === 0) {
      error = campoDeveSerMaiorQueZero
    }
    return error
  }

  validarParcelamento(parcelamento: string): string {
    let error = ''
    if (!parcelamento || parcelamento === '') {
      error = campoObrigatorio
    }
    return error
  }

  validarTodosCampos(state: DadosComercial): boolean {
    if (state.parcelamento != '' && this.parcelamento === '') {
      return true
    }
    return false
  }
}
